<!-- eslint-disable -->
<template lang="pug">
	div
		.form__title
			slot(name='title')
		form.form__body.form__body_small(action='javascript://' v-if='params')
			.form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
				label.form__label
					| {{ $i18n.t('trainer.trainer_gameFormSetting_partOfSpeech') }}
				.form__field-body
					cs-multiselect(
						:options="possiblePartsOfSpeech"
						v-model="params.partOfSpeech"
						:placeholder="partOfSpeechLabel(params.partOfSpeech)"
						:custom-label="partOfSpeechLabel"
						:multiple="false"
						:allow-empty="false"
					)
			.form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
				label.form__label
					| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfExamples') }}
				.form__field-body
					cs-spin-input(
						:value="params.amountOfExamples",
						:max="examples",
						:min="1",
						@increase="increaseExamples",
						@decrease="decreaseExamples",
						@input="params.amountOfExamples = $event",
					)
			.form__field(v-if="gameMode !== 'course' && gameMode !== 'generator-settings'")
				label.form__label
					| {{ $i18n.t('trainer.trainer_gameFormSetting_numOfVariants') }}
				.form__field-body
					cs-spin-input(
						:value="params.amountOfVariants",
						:max="variants",
						:min="3",
						@increase="increaseVariants",
						@decrease="decreaseVariants",
						@input="params.amountOfVariants = $event",
						)
			divider
			slot(name='parameters')
			slot(name='help')
			.form__buttons(v-if='!usersIds')
				cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
					| {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
				template(v-if="gameMode === 'free-game'")
					cs-button.form__button(color="blue", @click='saveGameMode')
						| {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
				template(v-else='')
					cs-button.form__button(color="blue", @click='saveGame')
						| {{ $i18n.t('trainer.trainer_gameFormSetting_saveGame') }}
			.form__buttons(v-else='')
				cs-button.form__button(@click='cancel', color="blue", pattern="primary-outline")
					| {{ $i18n.t('trainer.trainer_gameFormSetting_dontSave') }}
				cs-button.form__button(color="blue", @click='saveGame')
					| {{ $i18n.t('trainer.trainer_gameFormSetting_saveDifference') }}
</template>

<script>
    /*eslint-disable*/
    import GameFormMixin from "../../../utils/trainer/GameFormMixin";
    import TrainerGames from '../../../config/trainer';
    import { getInitParameters } from "../../../utils/trainer/getInitParameters";
    import { mapState } from 'vuex';
    import multiplayerFormMixin from "../../../utils/multiplayer/formMixin";

    export default {
        props: [
            'slug',
            'courseType',
            'id',
            'usersIds',
            'homeworkId',
            'gameMode',
            'levelAnswerDuration',
            'gameId',
            'generatorSettings',
            'generatorGameIndex'
        ],
        mixins: [GameFormMixin, multiplayerFormMixin],
        data () {
            return {
                params: null,
                examples: 100,
                variants: 100,
				possiblePartsOfSpeech: ['noun', 'adjective', 'verb'],
            }
        },
        mounted () {
            if (this.gameMode === 'free-game') {
                let paramsArray = this.$store.state.trainer.paramsArray;
                if (paramsArray && paramsArray[0] && paramsArray[0].slug === this.slug) {
                    this.paramsArray = _.cloneDeep(paramsArray);
                    this.$emit('playersNumber', this.paramsArray.length);
                    this.params = this.paramsArray[0];
                } else if (this.gamesParameters) {
                    this.$set(this, 'params', getInitParameters({
                        slug: this.slug,
                        parameters: {
                            default: _.cloneDeep(this.gamesParameters[this.slug])
                        }
                    }));
                } else {
                    this.params = _.cloneDeep(TrainerGames.games).find(item => item.slug === this.slug).parameters.default;
                }
            } else {
                this.setInitParams(this.getKey(this.usersIds));
            }
        },
        methods: {
            decreaseExamples () {
                if (this.params.amountOfExamples !== 1) {
                    this.params.amountOfExamples -= 1;
                }
            },
            increaseExamples () {
                if (this.params.amountOfExamples !== this.examples) {
                    this.params.amountOfExamples += 1;
                }
            },
            decreaseVariants() {
                if (this.params.amountOfVariants !== 3) {
                    this.params.amountOfVariants -= 1;
                }
            },
            increaseVariants() {
                if (this.params.amountOfVariants !== this.variants) {
                    this.params.amountOfVariants += 1;
                }
            },
			partOfSpeechLabel(partOfSpeech) {
				return this.$i18n.t('trainer.trainer_gameFormSetting_' + partOfSpeech);
			},
        },
        computed: {
            ...mapState({
                homework: state => state.trainer.homework,
                gamesParameters: state => state.trainer.gamesParameters,
                user: state => state.auth.user
            }),
        },
    }
</script>

<style lang="scss" scoped>
    .form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        text-align: center;
        margin-bottom: 25px;
    }

    .form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .form__body_small {
        margin: 0 auto;
        max-width: 1020px;
    }

    .form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            max-width: none;
            min-width: 13em;
        }
    }

    .form__field-body {
        flex-grow: 5;
    }

    .form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }
</style>

